export default __webpack_public_path__ + "static/media/190g.ca563ad4.svg";